import React from "react";
export var CanvasContext = /*#__PURE__*/React.createContext();
export var useCanvasContext = function () {
  var context = React.useContext(CanvasContext);

  if (!context) {
    throw new Error("This component must be wrapped in a CanvasContext.Provider component.\n      Try setting groupComponent={<CanvasGroup />} in your chart component.");
  }

  return context;
};